import React from 'react';
import { useCalendarNavigation } from '../context/CalendarNavigationContext';
import { CALENDAR_CONSTANTS } from '../utils/constants';

const CalendarTimeSlot = ({
  day,
  time,
  trainerId,
  selectable = false,
  children,
  onClick,
  className = '',
}) => {
  const { highlightedSlot } = useCalendarNavigation();

  const isHighlighted = highlightedSlot &&
    highlightedSlot.date === day.fullDate &&
    highlightedSlot.time === time &&
    (!highlightedSlot.trainerId || highlightedSlot.trainerId === trainerId);

  const handleClick = () => {
    if (selectable && onClick) {
      onClick({
        day,
        time,
        trainerId,
        date: day.date,
      });
    }
  };

  return (
    <div
      className={`
        calendar-time-slot
        ${selectable ? 'calendar-time-slot--selectable' : ''}
        ${isHighlighted ? 'calendar-time-slot--highlighted' : ''}
        ${className}
      `}
      style={{ height: CALENDAR_CONSTANTS.HOUR_HEIGHT }}
      onClick={handleClick}
      role={selectable ? 'button' : undefined}
      tabIndex={selectable ? 0 : undefined}
      onKeyDown={(e) => {
        if (selectable && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {children}

      {isHighlighted && (
        <div className="calendar-time-slot__highlight-pulse" />
      )}
    </div>
  );
};

export default CalendarTimeSlot;
